import { render, staticRenderFns } from "./RedemptionRecord.vue?vue&type=template&id=4a3e29e7&"
import script from "./RedemptionRecord.vue?vue&type=script&lang=js&"
export * from "./RedemptionRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports